import Firebase from './firebase';

// Initializing the firebase singleton object, all components use the same firebase
//		object exported from here, it never changes
const FIREBASE_SINGLETON = new Firebase();
export default FIREBASE_SINGLETON;
